import { Link, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/settings')({
  component: () => (
    <section className="p-6">
      <h1 className="text-2xl">Ustawienia</h1>
      <nav className="mt-4">
        <Link to="/settings/delete-account" className="text-sm text-red-300 underline">
          Usun konto
        </Link>
      </nav>
    </section>
  ),
})
